//import { AngularFirestoreCollection } from 'angularfire2/firestore';
import { AngularFirestore } from 'angularfire2/firestore';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, AlertController, LoadingController, ActionSheetController } from 'ionic-angular';
import { AuthDataProvider } from '../../providers/auth-data/auth-data';
import { HomePage } from '../home/home';
import { AngularFireAuth } from 'angularfire2/auth';
import { FormBuilder, Validators } from '@angular/forms';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { storage } from "firebase";
import * as firebase from 'firebase';
import 'firebase/firestore';
// import { FcmProvider } from '../../providers/fcm/fcm'



@IonicPage()
@Component({
  selector: 'page-profile',
  templateUrl: 'profile.html',
})
export class ProfilePage {

  public userInfo: any;
  profileForm: any;
  public myPhoto: string = '/../../assets/imgs/Logo-DirtyTalk-2019-01.png';
  private db: any;
  public email: any;
  public first_name: any;
  public gender: any;
  public last_name: any;
  public overage: any;
  public photo: any;
  public preference: any;
  public reading: any;
  public userID: any;
  public UID: any;
  public username: any;

  constructor(
    private toastCtrl: ToastController,
    private camera: Camera,
    private actionSheetCtrl: ActionSheetController,
    public afsModule: AngularFirestore,
    public navCtrl: NavController,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    public authData: AuthDataProvider,
    public afAuth: AngularFireAuth,
    public formBuilder: FormBuilder,
    public loadingCtrl: LoadingController,
    // public fcmProvider: FcmProvider
  ) {
    let ion = this;
    ion.profileForm = formBuilder.group({
      first_name: ['', Validators.compose([Validators.minLength(3), Validators.required])],
      last_name: ['', Validators.compose([Validators.minLength(3), Validators.required])],
      username: ['', Validators.compose([Validators.minLength(3), Validators.required])],
    });

    this.db = firebase.firestore();

  }


loadImg(){
        
}


  ionViewCanEnter() {
    console.log('ionViewDidLoad ProfilePage');
    let ion = this;

    this.userInfo = this.navParams.get('profile');
    ion.authData.getUserProfile().then(resdevice => {
      ion.email = resdevice.email
      ion.first_name = resdevice.first_name
      ion.gender = resdevice.gender
      ion.last_name = resdevice.last_name
      ion.overage = resdevice.overage
      ion.photo = resdevice.photo
      ion.preference = resdevice.preference
      ion.reading = resdevice.reading
      ion.userID = resdevice.userID
      ion.UID = resdevice.UID
      ion.username = resdevice.username

      console.log('resdeviceresdeviceresdevice homeeeeeeeeeeeee profgileeeeeeeee', resdevice);
      console.log("PROFIIIILE ion.UID:", ion.UID);
      
      // console.log("INFORMACION DE USUARIO", resdevice);
      // console.log("FOTO DE PERFIL ", ion.photo)
      // console.log("GENERO DEL USUARIO ", ion.gender)
      // console.log("CORREO DEL USUARIO ", ion.email)
      // console.log("ID DEL USUARIO", ion.userID);


      if (ion.photo === 'default' && ion.gender === 'M') {
        this.myPhoto = "/../../assets/imgs/male.jpg";
        if (ion.photo === 'default' && ion.gender === 'F') {
          this.myPhoto = "/../../assets/imgs/female.jpg";
        }
      } else {
        this.myPhoto = ion.photo;
      }
      console.log("MYPHOTO", this.myPhoto);
    });


    this.LoadingPicture();


  }


  ionViewWillLeave() {
    // this.LoadingPicture();
  }

  LoadingPicture() {
    let loading = this.loadingCtrl.create({
      cssClass: 'PictureProfile',
      spinner: 'bubbles',
      content: 'Cargando informacion...',
      showBackdrop: false,
    });
    loading.present();
    setTimeout(() => {
      loading.dismiss();
    }, 2000);
  }
 

  presentActionSheet() {
    const actionSheet = this.actionSheetCtrl.create({
      cssClass: 'menuCamera',
      title: 'Cambiar Imagen de Perfil',
      buttons: [
        // {
        //   icon: 'camera',
        //   text: 'Tomar Foto',
        //   handler: () => {
        //     this.takePhoto();
        //     console.log('CAMERA SELECTED');
        //   }
        // },
        {
          icon: 'image',
          text: 'Galeria',
          handler: () => {
            this.pickImage()
            console.log('GALERY SELECTED');
          }
        }, {
          icon: 'close-circle',
          text: 'Cerrar',
          role: 'cancel',
          handler: () => {
            console.log('OPTIONS CANCEL');
          }
        }
      ]
    });
    actionSheet.present();
  }
  ///////////////////////////////////////////////////////////////////////////////////////////
  pickImage() {
    const options: CameraOptions = {
      quality: 70,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
      saveToPhotoAlbum: false
    }
    this.camera.getPicture(options).then((DATA_URL) => {
      // let Base64Photo = 'data:image/jpeg;base64,' + DATA_URL; // obtenemos la imagen en base64
      let Base64Photo = DATA_URL;
      this.myPhoto = 'data:image/jpeg;base64,' + DATA_URL;
      let randomString = Math.random().toString(36).replace(/[^a-z]+/g, ''); // obtenemos un random string para generarle un nombre al archivo
      let actualDate = new Date().getTime();  // obtenemos fecha actual para concatenar en el nombre del archivo
      let fileName = this.email + '-' + randomString + '-' + actualDate + '.jpg';  // generamos el nombre del archivo con id de usuario-el randomstring-la fecha actual .jpg que es el formato que se le dara mas adelante al guardar

      storage().ref('/ProfilePictures/' + this.userID).child(fileName)  //this.userID  es el usuario logeado actualmente! fileneame es el nombre del archivo que generamos arriba
        .putString(Base64Photo, 'base64', { contentType: 'image/jpg' })
        .then(res => { //guardamos la imagen con el formato base64 y le damos formato de contenido para firebase
          storage().ref('/ProfilePictures/' + this.userID).child(fileName).getDownloadURL() // accedemos a la misma ruta de la imagen en la carpeta pictures, carpeta de idUser y ubicamos el archivo con fileName,
            .then(url => { //llamamos a la funcion getDownloadURL() y obtenemos el url de la misma
              console.log('urlurl', url); // este es el url de la imagen que acabamos de guardar
              //llamamos a otra funcion para guardar ese url en el documento del usuario
              this.savePicture(url);

            })
            .catch(err => {
              console.log('cannot get url of picture', err);
            });
        })
        .catch(err => {
          console.log('error saving base64 data url photo', err);

        });
    }, (err) => {
      console.error('ERRRRROOOORRRR.', err);
    });
  }
  /////////////////////////////////////////
  savePicture(url) {
    let ion = this;

    var urlPicture = url;
    // console.log("ESTA ES LA URL QUE LA PROFILE-PICTURE", urlPicture);
    // console.log("ESTE ES EL DOCUMENTO DONDE DESEO CARGAR LA URL", ion.userID);
    // console.log("ESTA ES LA IMAGEN QUE TIENE ACTUALMENTE EL USUARIO", ion.photo);

    ion.db.collection("users").doc(ion.userID).update({
      // email: this.email,
      // first_name: this.first_name,
      // gender: this.gender,
      // last_name: this.last_name,
      // overage: this.overage,
      photo: urlPicture
      // preference: this.preference,
      // reading: this.reading,
      // // userID: ion.userID.userID,
      // UID: this.UID,
      // username: this.username,
    }).then(function () {
      console.log("ProfilePicture successfully written!");
    })
      .catch(function (error) {
        console.error("Error saving ProfilePicture: ", error);
      });

  }

  // LoadingPicture() {
  //   let loading = this.loadingCtrl.create({
  //     spinner: 'bubbles',
  //     content: 'Guardando Imagen Seleccionada...',
  //     showBackdrop: false
  //   });
  //   loading.present();
  //   setTimeout(() => {
  //     loading.dismiss();
  //   }, 4000);
  // }
  ///////////////////////////////////////////////////////////////////////////////////////////
  editUser(user) {
    let ion = this;
    let loadingPopupLogin = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopupLogin.present();
    console.log("estoo mando algo??", user);
    this.authData.updateProfile(user).then(function (useres) {
      console.log('Saved successfully', useres);
      loadingPopupLogin.dismiss();
      ion.presentAlert("Su informacion se ha guardado con exito");;

    }).catch(error => {
      loadingPopupLogin.dismiss();
      ion.presentAlert("Error al guardar")
      console.log("Error updating data:", error);
    });
  }

  presentAlert(title, message = "") {
    return new Promise((Resolve, Reject) => {
      let ion = this;
      let alert = ion.alertCtrl.create({
        enableBackdropDismiss: false,
        cssClass: 'alertCustomCss1',
        title: title,
        message: message,
        buttons: [
          {
            text: 'OK',
            handler: () => {
              console.log('VOLVIENDO AL HOME');
              Resolve(true);
              this.navCtrl.setRoot(HomePage);
            }
          }]
      });
      alert.present();
    })
  }
  presentToast(position: string, message: string) {
    let toast = this.toastCtrl.create({
      message: message,
      position: position,
      duration: 3000
    });
    toast.present();
  }

  ///////////////////////////
  // logOut() {
  //   this.authData.logoutUser()
  //     .then(authData => {
  //       this.afAuth.auth.signOut();
  //       console.log("Logged out");
  //       // toast message
  //       this.presentToast('bottom', "Acaba de cerrar sesión, Feliz Día!");
  //       this.navCtrl.setRoot(HomePage);
  //     }, error => {
  //       this.presentAlert(error);
  //     });
  // }

  logOut() {
    this.authData.logoutUser()
      .then(authData => {
        console.log("Logged out");
        // this.fcmProvider.unregisterGlobalToken()
        // toast message
        this.presentToast('bottom', "Acaba de cerrar sesión, Feliz Día!");
        this.navCtrl.setRoot(HomePage);
      }, error => {
        this.presentAlert(error);
      });
  }

  selectAvatar(avatar) {
    console.log('selecting avatar', avatar);
    let newPhoto = "/../../assets/imgs/" + avatar;
    this.myPhoto = newPhoto;
    this.userInfo.photo = newPhoto;
  }

}



// WEBPACK FOOTER //
// ./src/pages/profile/profile.ts